<ng-container [ngSwitch]="headingStyle">
  <p *ngSwitchCase="'inline'" class="typog-label" data-id="booking-ref-title">
    {{ 'MMR.GROUPS.' + groupTitle | translate }}
  </p>
  <h3 *ngSwitchDefault class="typog-label">
    {{ 'MMR.GROUPS.' + groupTitle | translate }}
  </h3>
</ng-container>

<ng-content> </ng-content>
